import { getPhotographer, getAllMediasForPhotographer } from "../../../app/lib/prisma-db";
import PhotographerHeader from "./components/PhotographerHeader/PhotographerHeader";
import PhotographerPage from "./components/PhotographerPage/PhotographerPage";

export default async function Page({params}){
    const { slug } = await params;
    const id = parseInt(slug.split("-")[0]);
    const photographer = await getPhotographer(id);
    const medias = await getAllMediasForPhotographer(id);

    return(
        <>
            <PhotographerHeader />
            <PhotographerPage
                photographer={photographer}
                medias={medias}
            />
        </>
    )
}

